export default "__VITE_ASSET__$LsDdyex__"